import getTypographyColorStyles from 'src/styles/functions/getTypographyColorStyles';
import styled, { css } from 'styled-components';
import { layout } from '../../styles/layout';

type StandardParagraphSizeKeys = '3' | '2' | '1.5' | '1.125' | '1' | '0.875' | '0.75' | '0.625';
export type ParagraphAvailableFontSizes =
  | '3rem'
  | '2.4rem'
  | '2rem'
  | '1.8rem'
  | '1.5rem'
  | '1.125rem'
  | '1rem'
  | '0.875rem'
  | '0.75rem'
  | '0.625rem';

export interface IStandardParagraphSize {
  desktop: ParagraphAvailableFontSizes;
  lg?: ParagraphAvailableFontSizes;
  sm?: ParagraphAvailableFontSizes;
}

export const StandardParagraphSize: Record<StandardParagraphSizeKeys, IStandardParagraphSize> = {
  '3': {
    desktop: '3rem',
    lg: '2.4rem',
    sm: '1.8rem',
  },
  '2': {
    desktop: '2rem',
    lg: '1.5rem',
    sm: '1.125rem',
  },
  '1.5': {
    desktop: '1.5rem',
    lg: '1.125rem',
    sm: '1rem',
  },
  '1.125': {
    desktop: '1.125rem',
    sm: '1rem',
  },
  '1': {
    desktop: '1rem',
  },
  '0.875': {
    desktop: '0.875rem',
  },
  '0.75': {
    desktop: '0.75rem',
  },
  '0.625': {
    desktop: '0.625rem',
  },
};

export type StandardParagraphSize = keyof typeof StandardParagraphSize;

export interface StandardizedParagraphSizeProps {
  standardSize?: StandardParagraphSize;
}

export interface StyledParagraphProps extends StandardizedParagraphSizeProps {
  align?: 'center' | 'left' | 'right';
  // TODO: Replace sizes types with ParagraphAvailableFontSizes once the font sizes are migrated
  size?: string;
  sizeXlg?: string;
  sizeSubxlg?: string;
  sizeLg?: string;
  sizeSubLg?: string;
  sizeMd?: string;
  sizeSubMd?: string;
  sizeSm?: string;
  sizeXs?: string;
  sizeXxs?: string;
  weight?: 'normal' | 'light' | number;
  lineHeight?: string;
  color?: string;
  letterSpacing?: number;
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize';
}

export const StyledParagraph = styled.p<StyledParagraphProps>`
  font-size: ${({ size }) => size};
  font-weight: ${({ weight = 'light' }) => (typeof weight === 'number' ? weight : weight === 'light' ? '300' : '700')};
  text-align: ${({ align }) => align || 'left'};
  font-family: Mulish, Arial, sans-serif;
  margin: 0px;
  line-height: ${({ lineHeight }) => lineHeight || '1.375'};
  white-space: pre-line;

  ${({ letterSpacing }) =>
    letterSpacing
      ? css`
          letter-spacing: ${letterSpacing}px;
        `
      : ''}

  ${({ textTransform }) =>
    textTransform
      ? css`
          text-transform: ${textTransform};
        `
      : ''}

  ${({ sizeXlg }) =>
    !sizeXlg
      ? ''
      : `
    @media all and (max-width: ${layout.xlg}) {
        font-size: ${sizeXlg};
    }`}
  ${({ sizeSubxlg }) =>
    !sizeSubxlg
      ? ''
      : `
    @media all and (max-width: ${layout.subxlg}) {
        font-size: ${sizeSubxlg};
    }`}
    ${({ sizeLg }) =>
    !sizeLg
      ? ''
      : `
    @media all and (max-width: ${layout.lg}) {
        font-size: ${sizeLg};
    }`}
    ${({ sizeSubLg }) =>
    !sizeSubLg
      ? ''
      : `
    @media all and (max-width: ${layout.subLg}) {
        font-size: ${sizeSubLg}};
    }`}
    ${({ sizeMd }) =>
    !sizeMd
      ? ''
      : `
    @media all and (max-width: ${layout.md}) {
        font-size: ${sizeMd};
    }`}
    ${({ sizeSubMd }) =>
    !sizeSubMd
      ? ''
      : `
    @media all and (max-width: ${layout.subMd}) {
        font-size: ${sizeSubMd};
    }`}
    ${({ sizeSm }) =>
    !sizeSm
      ? ''
      : `
    @media all and (max-width: ${layout.sm}) {
        font-size: ${sizeSm};
    }`}
    ${({ sizeXs }) =>
    !sizeXs
      ? ''
      : `
    @media all and (max-width: ${layout.xs}) {
        font-size: ${sizeXs};
    }`}
    ${({ sizeXxs }) =>
    !sizeXxs
      ? ''
      : `
    @media all and (max-width: ${layout.xxs}) {
        font-size: ${sizeXxs};
    }`}

    ${({ color }) => (!color ? '' : getTypographyColorStyles(color))}
`;
